// Presentation contract for the tax row in year-end closing.
// A calculation is not evidence that a person has reviewed the tax basis.
(function registerYearClosingTaxStatus(global) {
  const list = (value) => Array.isArray(value) ? value : [];

  const build = ({ accountingScope, result, hasTaxProvision, taxProcess, translate }) => {
    const tr = typeof translate === 'function' ? translate : (_key, fallback) => fallback;
    const regime = String(accountingScope?.taxRegime || 'unknown');
    const reviewed = list(taxProcess?.confirmedStepIds).includes('tax-base') || Boolean(taxProcess?.submittedAt);
    const common = {
      id: 'tax',
      label: tr('clo.checklist.tax.label', 'Skatteberegning'),
      canOpen: true,
      openLabel: tr('clo.checklist.tax.open', 'Åpne beregning og forskjeller'),
    };

    if (regime === 'unknown') return {
      ...common,
      status: 'todo', count: 1, taxStage: 'calculated',
      stageLabel: tr('clo.checklist.tax.stage.calculated', 'Beregnet'),
      detail: tr('clo.checklist.tax.unknownRegimeDetail', 'Skatteregimet må avklares for selskapsformen.'),
    };
    if (regime !== 'company') return {
      ...common,
      canOpen: false,
      status: 'na', count: 0, taxStage: 'not_applicable',
      detail: tr('clo.checklist.tax.notCompanyDetail', 'Selskapsskatt er ikke aktuelt for denne selskapsformen.'),
    };
    if (hasTaxProvision) return {
      ...common,
      status: 'ok', count: 0, taxStage: 'posted',
      stageLabel: tr('clo.checklist.tax.stage.posted', 'Postert'),
      detail: tr('clo.checklist.tax.postedDetail', 'Skattekostnad og betalbar skatt er postert.'),
    };
    if (reviewed) return {
      ...common,
      status: 'ok', count: 0, taxStage: 'reviewed',
      stageLabel: tr('clo.checklist.tax.stage.reviewed', 'Kontrollert'),
      detail: tr('clo.checklist.tax.controlledDetail', 'Skattegrunnlaget er kontrollert. Sluttposteringen opprettes ved lukking.'),
    };

    const amount = Number(result) || 0;
    return {
      ...common,
      status: 'todo', count: 1, taxStage: 'calculated',
      stageLabel: tr('clo.checklist.tax.stage.calculated', 'Beregnet'),
      detail: amount < -0.005
        ? tr('clo.checklist.tax.lossDetail', 'Beregningen viser underskudd og ingen betalbar skatt. Skattegrunnlaget må fortsatt kontrolleres.')
        : Math.abs(amount) <= 0.005
          ? tr('clo.checklist.tax.zeroDetail', 'Beregningen viser null i resultat og ingen betalbar skatt. Skattegrunnlaget må fortsatt kontrolleres.')
          : tr('clo.checklist.tax.reviewDetail', 'Skatten er beregnet. Kontroller skattegrunnlaget og forskjellene før sluttposteringen opprettes.'),
    };
  };

  global.PlummeYearClosingTaxStatus = { build };
})(window);
